import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoginService } from '../service/loginservice';
import { UserService } from '../service/userService';
import { UserRecord } from '../model/userRecord';
import { AdalService } from 'adal-angular4';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';
import { GlobalService } from '../service/globalService';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit, OnDestroy {
  model: any = {};
  loading = false;
  userName: string;
  isAuthenticated: boolean;
  User: string;
  private oauthEventsSub: Subscription;

  constructor(
    private adalService: AdalService,
    private loginService: LoginService,
    private router: Router,
    private userService: UserService,
    private globalService: GlobalService,
    private oauthService: OAuthService,
    private messageService: MessageService
  ) {
  }

  ngOnInit(): void {
    console.log('Login init - has valid ID token?', this.oauthService.hasValidIdToken());
    if (this.oauthService.hasValidIdToken()) {
      const claims = this.oauthService.getIdentityClaims();
      if (claims) {
        this.User = claims['preferred_username'];
        this.loadData(this.User);
      }
      return;
    }
  }

  ngOnDestroy(): void {
    if (this.oauthEventsSub) {
      this.oauthEventsSub.unsubscribe();
    }
  }

  private loadData(user: string): void {
    this.isAuthenticated = true;
    console.log(this.adalService.userInfo);
    this.userService.getUserByEmail(user).subscribe(
      data => {
        if (!data) {
          this.router.navigate(['no-auth']);
          return;
        }
        const userRec = new UserRecord().deserialize(data);
        localStorage.setItem('currentUser', JSON.stringify(userRec));

        if (!this.globalService.UserToken) {
          this.userService.getUserToken(userRec.username).subscribe(
            result => {
              if (result) {
                this.globalService.UserToken = result;
                if (userRec.is_active) {
                  this.router.navigate(['content-protection/tasks']);
                } else {
                  this.messageService.clear();
                  this.messageService.add({ severity: 'warn', summary: 'User is not an active user!!' });
                  localStorage.setItem('Status', 'Inactive');
                  this.router.navigate(['no-auth']);
                }
              } else {
                localStorage.removeItem('currentUser');
                this.router.navigate(['no-auth']);
              }
              this.globalService.setLoadingOff();
            },
            error => {
              this.messageService.clear();
              this.messageService.add({
                severity: 'error',
                summary: 'There was an error retrieving api token from server',
                detail: error.message
              });
              localStorage.removeItem('currentUser');
              this.router.navigate(['no-auth']);
              this.globalService.setLoadingOff();
            }
          );
        } else {
          if (userRec.is_active) {
            this.router.navigate(['content-protection/tasks']);
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'warn', summary: 'User is not an active user!!' });
            localStorage.setItem('Status', 'Inactive');
            this.router.navigate(['no-auth']);
          }
        }
      },
      error => {
        console.log('Error retrieving user records:', error);
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary: 'There was an error retrieving user records from server',
          detail: error.message
        });
      }
    );
  }

  login(): void {
    this.oauthService.initImplicitFlow();
  }

  logout(): void {
    this.oauthService.logOut();
  }

  redirecttotask() {
    this.router.navigate(['content-protection/tasks']);
  }
}
